import {
  loadRecommendationsForEventsOverviews,
  loadRecommendationsPlaces,
} from "@common/redux/slices/recommendation.slice";
import { useLocaleFilter } from "@common/hooks/useLocaleFilter";
import { checkLocales } from "@common/utils/locales";
import { reduxWrapper } from "@common/redux/store";
import { Events } from "@kursk/components/pages/Events/Events";
import { loadEntitiesFromQuery } from "@kursk/utils/loadEntitiesFromQuery";
import { loadPrices } from "@common/redux/slices/minAndMaxPrices.slice";

export default function EventsPage() {
  useLocaleFilter();

  return <Events />;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, query, res, req, ...data }) => {
  const checkResult = await checkLocales(data['resolvedUrl'], query, req, res, store);
  if (checkResult) return checkResult;

  await Promise.all([
    loadEntitiesFromQuery('events', query, store),
    store.dispatch(loadRecommendationsPlaces({ locales: query.locales })),
    store.dispatch(loadRecommendationsForEventsOverviews({})),
    store.dispatch(loadPrices('events')),
  ]);

  return { props: {} };
})
